import type { LabeledValuePayload } from '@Application/Users/UserStatuses/Actions/userStatusesFetched';

export type SubjectTypeAccessLevelsFetchedPayload = LabeledValuePayload[];

export type SubjectTypeAccessLevelsFetchedAction = {
	type: 'SUBJECT_TYPE_ACCESS_LEVELS_FETCHED';
	payload: SubjectTypeAccessLevelsFetchedPayload;
};

export default (payload: SubjectTypeAccessLevelsFetchedPayload): SubjectTypeAccessLevelsFetchedAction => ({
	type: 'SUBJECT_TYPE_ACCESS_LEVELS_FETCHED',
	payload,
});
